module.exports = __webpack_public_path__ + "img/freedomblur.d4372dbb.jpg";